/**
 * 组件信息
 */
export const info = {
  name: 'xy-fixed-layout', // 组件名
  type: 'component-container', // 组件类型
  label: '固定布局', // 组件label
  icon: 'icon-xy-absolute-layout', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 400 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  top: { type: [Number, String], default: 0 },
  left: { type: [Number, String], default: 0 },
  bottom: { type: [Number, String], default: 0 },
  element: {
    type: Object,
    default: () => ({
      // 组件名称
      name: '',
      // 组件类型
      type: '',
      // 组件id
      uuid: '',
      // 隐藏
      hiden: false,
      // 动画
      animations: [],
      // 组件样式
      style: {},
      // 组件数据
      data: {},
      // 多语言
      languages: [],
      // 数据源
      dataSource: null,
      // 事件
      events: []
    })
  },
  language: {
    type: String,
    default: 'en'
  }
}

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-input', // 表单组件
    label: '距离顶部', // 表单名称
    propKey: 'top' // 表单model字段名称
  },
  {
    type: 'xy-form-input', // 表单组件
    label: '距离底部', // 表单名称
    propKey: 'bottom' // 表单model字段名称
  },
  {
    type: 'xy-form-input', // 表单组件
    label: '距离左侧', // 表单名称
    propKey: 'left' // 表单model字段名称
  }
]
